import React, { useState, useEffect, useRef } from "react";
import api from "../../api/api";

export default function VideoUploadPlayer({ lesson, onFinish }) {
  const videoRef = useRef(null);
  const lastSentRef = useRef(0);
  const [initialTime, setInitialTime] = useState(0); // Estado para armazenar o tempo vindo do BD
  const BACKEND_URL = "https://imagensdaface.com.br";
  const SAVE_INTERVAL = 5;

  const videoSrc = lesson?.content?.startsWith("http") 
    ? lesson.content 
    : `${BACKEND_URL}/${lesson?.content?.replace(/^\//, "")}`;

  // 1. Busca o progresso no BD assim que a aula muda
  useEffect(() => {
    const loadInitialProgress = async () => {
      try {
        const res = await api.get(`/lessons/${lesson.id}/progress`);
        // Note que o campo no seu banco é 'current_time_seconds'
        if (res.data && res.data.current_time_seconds > 0) {
          setInitialTime(res.data.current_time_seconds);
        } else {
          setInitialTime(0);
        }
      } catch (err) {
        console.error("Erro ao carregar progresso:", err);
      }
    };

    if (lesson?.id) {
      loadInitialProgress();
    }
  }, [lesson.id]);

  // 2. Aplica o tempo salvo APENAS quando o vídeo carregar os metadados
  const handleLoadedMetadata = () => {
    if (initialTime > 0 && videoRef.current) {
      videoRef.current.currentTime = initialTime;
      lastSentRef.current = initialTime;
    }
  };

  const saveProgress = async (isFinished = false) => {
    const video = videoRef.current;
    if (!video || !video.duration) return;

    const current = Math.floor(video.currentTime);
    const duration = Math.floor(video.duration);

    if (current === 0 && !isFinished) return;
    if (!isFinished && (current - lastSentRef.current < SAVE_INTERVAL)) return;
    
    lastSentRef.current = current;

    try {
      // Usando o endpoint POST que você já tem no lessonRoutes.js
      await api.post(`/lessons/${lesson.id}/progress`, {
        current_time_seconds: current,
        duration_seconds: duration,
        status: isFinished ? "completed" : "watching"
      });

      if (isFinished && onFinish) {
        onFinish();
      }
    } catch (err) {
      console.error("Erro ao salvar progresso:", err);
    }
  };

  return (
    <div className="w-full bg-black rounded-xl overflow-hidden shadow-2xl aspect-video flex items-center">
      <video
        key={lesson.id} 
        ref={videoRef}
        src={videoSrc}
        controls
        preload="metadata"
        playsInline
        className="w-full h-full"
        onLoadedMetadata={handleLoadedMetadata} // <-- CRUCIAL PARA O RESUME FUNCIONAR
        onTimeUpdate={() => saveProgress(false)}
        onEnded={() => saveProgress(true)}
      >
        Seu navegador não suporta a reprodução de vídeo.
      </video>
    </div>
  );
}